// Note: Move this to vss-platform if needed
/// <amd-module name="Build/Flux/Action" />
export class Action<T> {

    /**
     * A mutex to ensure that only one action is executing at any time. 
     * This prevents cascading actions.
     */
    private static s_executing: boolean = false;

    private _listeners: ((payload: T) => void)[] = [];

    public invoke(payload: T): void {
        if (Action.s_executing) {
            throw new Error("Cannot invoke an action from inside another action.");
        }

        Action.s_executing = true;

        try {
            this._listeners.forEach((listener: (payload: T) => void) => {
                listener(payload);
            });
        }
        finally {
            Action.s_executing = false;
        }
    }

    /**
     * Add listener to the action
     * @param listener Listener to add
     * @param context Optional context to bind to listener
     * @returns Listener that was added, might be different from the passed in listener if context is given
     */
    public addListener(listener: (payload: T) => void, context?: any): (payload: T) => void {
        let l = context ? listener.bind(context) : listener
        this._listeners.push(l);
        return l;
    }

    /**
     * Remove listener from the action
     * @param listener Listener to remove
     */
    public removeListener(listener: (payload: T) => void): void {
        let index = this._listeners.indexOf(listener);
        if (index >= 0) {
            this._listeners.splice(index, 1);
        }
    }
}
